export const environment = {
  production: false,
  // apiUrl: 'http://localhost:4000/new-heights-dev-api/v1/',
  apiUrl: 'https://dev.newheightsgame.com/api/v1/',
  baseUrl: 'https://dev.newheightsgame.com',
};
